import {useRef} from 'react';

import {useTooltipTrigger} from '@react-aria/tooltip';
import {useTooltipTriggerState} from '@react-stately/tooltip';

import {Tooltip, TooltipTextPrimary} from '@time-webkit/all/atoms/tooltip';

const TOOLTIP_TRIGGER_STATE = {delay: 500};
const TOOLTIP_TRIGGER_PROPS = {};

type Props = {
    tooltipText?: string;
    isDisabled?: boolean;
};

export const useButtonTooltip = ({tooltipText, isDisabled}: Props) => {
    const triggerRef = useRef(null);

    const tooltipState = useTooltipTriggerState(TOOLTIP_TRIGGER_STATE);
    const {triggerProps, tooltipProps} = useTooltipTrigger(
        TOOLTIP_TRIGGER_PROPS,
        tooltipState,
        triggerRef,
    );

    const showTooltip = tooltipText && tooltipState.isOpen && !isDisabled;
    const renderWithTooltip = (children: React.ReactNode) => (
        <>
            <span {...triggerProps} ref={triggerRef}>
                {children}
            </span>
            {showTooltip && (
                <Tooltip
                    {...tooltipProps}
                    state={tooltipState}
                    targetRef={triggerRef}
                    offset={6}
                >
                    <TooltipTextPrimary>{tooltipText}</TooltipTextPrimary>
                </Tooltip>
            )}
        </>
    );

    return {renderWithTooltip};
};
